import { render, staticRenderFns } from "./DashboardSnitchStatus.vue?vue&type=template&id=6165ec72&scoped=true"
import script from "./DashboardSnitchStatus.vue?vue&type=script&lang=js"
export * from "./DashboardSnitchStatus.vue?vue&type=script&lang=js"
import style0 from "./DashboardSnitchStatus.vue?vue&type=style&index=0&id=6165ec72&prod&lang=scss&scoped=true"
import style1 from "./DashboardSnitchStatus.vue?vue&type=style&index=1&id=6165ec72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6165ec72",
  null
  
)

export default component.exports